import React from 'react';
import { ICaseBattleGame } from '@/utils/types/ICaseBattle';
import GameBattleAvatar from '@/components/CaseBattles/Game/Avatar/GameBattleAvatar';

interface Props {
    game: ICaseBattleGame;
    placeholder: (teamId: number) => React.ReactNode;
}

const BasePlayers = ({ game, placeholder }: Props) => {
    return (
        <div className="flex items-center gap-1.5">
            {game.teams.map((team, index) => {
                const remain = game.teamsParticipantsCount - team.participants.length;
                return (
                    <React.Fragment key={team.id}>
                        {index > 0 && game.type === 'TWO_VS_TWO' && (
                            <span className="text-[10px] font-extrabold tracking-[0.10em] text-text_4 mx-1">
                                VS
                            </span>
                        )}
                        <div className="flex items-center gap-1">
                            {team.participants.map((p) => (
                                <GameBattleAvatar
                                    key={p.id}
                                    player={p}
                                    gameStatus={game.status}
                                />
                            ))}
                            {Array.from({ length: remain }).map((_, i) => (
                                <React.Fragment key={i}>
                                    {placeholder(team.id)}
                                </React.Fragment>
                            ))}
                        </div>
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default BasePlayers;
